<?xml version="1.0" encoding="UTF-8"?>
<svg width="15px" height="14px" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M9,0 L9,5.5 L14.5,5.5 L14.5,8.5 L9,8.5 L9,14 L6,14 L6,8.5 L0.5,8.5 L0.5,5.5 L6,5.5 L6,0 L9,0 Z" id="Combined-Shape" fill="#D8D8D8"></path>
    </g>
</svg>